import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { HowtoPage } from "../components/howto/HowtoPage";
import { howtoHead } from "../lib/howto/head";
import { howtoPath, howtoSlugOf, loadHowto } from "../lib/howto/index";
import { HOWTO_UI } from "../lib/howto/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";
import { loadToolCopy } from "../lib/tools/index";

/** `/<lang>/how-to/<slug>`. Same 301 rule as every other localized route. */
export const Route = createFileRoute("/$lang/how-to/$slug")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();
    const slug = howtoSlugOf(params.slug);
    if (!slug) throw notFound();

    const path = howtoPath(slug, lang);
    if (path !== `/${params.lang}/how-to/${params.slug}`)
      throw redirect({ href: path, statusCode: 301 });

    const [bundle, toolCopy] = await Promise.all([
      loadHowto(lang),
      loadToolCopy(lang),
    ]);
    return { lang, slug, bundle, toolCopy };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? howtoHead(
          loaderData.slug,
          loaderData.lang,
          loaderData.bundle[loaderData.slug],
          HOWTO_UI[loaderData.lang],
        )
      : {},
  component: LocalizedGuide,
});

function LocalizedGuide() {
  const { lang, slug, bundle, toolCopy } = Route.useLoaderData();
  return (
    <HowtoPage
      slug={slug}
      guide={bundle[slug]}
      ui={HOWTO_UI[lang]}
      lang={lang}
      bundle={bundle}
      toolCopy={toolCopy}
    />
  );
}
